import { __decorate } from "tslib";
import { Component, Prop, Vue } from "vue-property-decorator";
import Money from "@/components/Money.vue";
let InvoiceTable = class InvoiceTable extends Vue {
    invoice;
    get showTeeth() {
        return this.invoice.services.some(el => (el.tooths || []).length) && this.$settings.showTeethInInvoice;
    }
    get paymentRowColspan() {
        return this.showTeeth ? 4 : 3;
    }
    formatTeeth(item) {
        const teeth = (item.tooths || []);
        return teeth.join(', ');
    }
};
__decorate([
    Prop({ type: Object, required: true })
], InvoiceTable.prototype, "invoice", void 0);
InvoiceTable = __decorate([
    Component({
        components: { Money }
    })
], InvoiceTable);
export default InvoiceTable;
